import { SegmentCustomFieldFragment } from 'common/src/generated/types';
import * as React from 'react';

export function useSlugToCustomField(customFields: SegmentCustomFieldFragment[]) {
    return React.useMemo(() => new Map(customFields.map((cf) => [cf.slug, cf])), [customFields]);
}
